import { render } from "./WebShopSuccess.vue?vue&type=template&id=2137f9e7&scoped=true&ts=true"
import script from "./WebShopSuccess.vue?vue&type=script&lang=ts"
export * from "./WebShopSuccess.vue?vue&type=script&lang=ts"

import "./WebShopSuccess.vue?vue&type=style&index=0&id=2137f9e7&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2137f9e7"]])

export default __exports__